import {
  LoanOfficer,
  Manager,
  computeReviewStatus,
  getWeekReview,
  REVIEW_CATEGORY_KEYS,
} from '../data/mockData'

const STATUS_LABEL: Record<string, string> = {
  complete: 'Complete',
  in_progress: 'In Progress',
  not_started: 'Not Started',
}

function escapeCsv(value: string | number): string {
  const str = String(value ?? '')
  if (/[",\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`
  }
  return str
}

export function exportReviewsToCsv(
  los: LoanOfficer[],
  managers: Manager[],
  selectedWeek: string,
  fileLabel: string,
) {
  const headers = [
    'Loan Officer',
    'Team',
    'Manager',
    'Review Status',
    'Sections Completed',
    'Accountability Score',
    'Prior Score',
    'Health',
    'Applications',
    'Submissions',
    'Closings',
    'Conversion %',
    'Last Review Date',
  ]

  const rows = los.map((lo) => {
    const review = getWeekReview(lo, selectedWeek)
    const status = computeReviewStatus(review)
    const sectionsCompleted = review
      ? REVIEW_CATEGORY_KEYS.filter((k) => (review[k] as any).completed).length
      : 0
    const manager = managers.find((m) => m.id === lo.managerId)
    return [
      lo.name,
      lo.team,
      manager?.name ?? '',
      STATUS_LABEL[status] ?? status,
      `${sectionsCompleted}/${REVIEW_CATEGORY_KEYS.length}`,
      lo.accountabilityScore,
      lo.priorMonthScore,
      lo.healthIndicator,
      lo.production.applications,
      lo.production.submissions,
      lo.production.closings,
      lo.production.conversionRate,
      lo.lastReviewDate,
    ]
  })

  const csv = [headers, ...rows]
    .map((row) => row.map(escapeCsv).join(','))
    .join('\n')

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  const safeLabel = fileLabel.replace(/[^a-z0-9]+/gi, '-').toLowerCase()
  link.href = url
  link.download = `${safeLabel}-${selectedWeek}.csv`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
